import { alertService } from '../services/alertService';

// Modales de confirmation personnalisées
export const confirmationModals = {
  // Confirmation de suppression d'un contact
  deleteContact: async (contactName) => {
    return await alertService.confirmDelete(
      'Supprimer le contact',
      `Êtes-vous sûr de vouloir supprimer le contact "${contactName}" ? Cette action est irréversible.`,
      {
        confirmButtonText: 'Oui, supprimer',
        cancelButtonText: 'Annuler',
        icon: 'warning'
      }
    );
  },

  // Confirmation de suppression d'un groupe
  deleteGroup: async (groupName) => {
    return await alertService.confirmDelete(
      'Supprimer le groupe',
      `Êtes-vous sûr de vouloir supprimer le groupe "${groupName}" ? Tous les contacts de ce groupe seront déplacés vers "Non groupés".`,
      {
        confirmButtonText: 'Oui, supprimer',
        cancelButtonText: 'Annuler',
        icon: 'warning'
      }
    );
  },

  // Confirmation de suppression d'une campagne
  deleteCampaign: async (campaignName) => {
    return await alertService.confirmDelete(
      'Supprimer la campagne',
      `Êtes-vous sûr de vouloir supprimer la campagne "${campaignName}" ? Cette action supprimera également tous les logs associés.`,
      {
        confirmButtonText: 'Oui, supprimer',
        cancelButtonText: 'Annuler',
        icon: 'warning'
      }
    );
  },

  // Confirmation d'arrêt d'une campagne
  stopCampaign: async (campaignName) => {
    return await alertService.confirm(
      'Arrêter la campagne',
      `Voulez-vous arrêter la campagne "${campaignName}" ? Les SMS en cours d'envoi seront terminés mais les SMS en attente seront annulés.`,
      {
        confirmButtonText: 'Arrêter',
        cancelButtonText: 'Continuer',
        icon: 'question'
      }
    );
  },

  // Confirmation de démarrage d'une campagne
  startCampaign: async (campaignName, contactCount) => {
    return await alertService.confirm(
      'Démarrer la campagne',
      `Voulez-vous démarrer la campagne "${campaignName}" ?\n\n${contactCount} contacts recevront le SMS.`,
      {
        confirmButtonText: 'Démarrer',
        cancelButtonText: 'Annuler',
        icon: 'question'
      }
    );
  },

  // Confirmation de modification d'un contact
  editContact: async (contactName) => {
    return await alertService.confirm(
      'Modifier le contact',
      `Voulez-vous modifier les informations du contact "${contactName}" ?`,
      {
        confirmButtonText: 'Modifier',
        cancelButtonText: 'Annuler',
        icon: 'question'
      }
    );
  },

  // Confirmation de modification d'un groupe
  editGroup: async (groupName) => {
    return await alertService.confirm(
      'Modifier le groupe',
      `Voulez-vous modifier les paramètres du groupe "${groupName}" ?`,
      {
        confirmButtonText: 'Modifier',
        cancelButtonText: 'Annuler',
        icon: 'question'
      }
    );
  },

  // Confirmation d'import de contacts
  importContacts: async (fileName, contactCount) => {
    return await alertService.confirm(
      'Importer les contacts',
      `Voulez-vous importer ${contactCount} contacts depuis le fichier "${fileName}" ?\n\nLes doublons seront automatiquement détectés et ignorés.`,
      {
        confirmButtonText: 'Importer',
        cancelButtonText: 'Annuler',
        icon: 'question'
      }
    );
  },

  // Confirmation d'export de contacts
  exportContacts: async (format, contactCount) => {
    return await alertService.confirm(
      'Exporter les contacts',
      `Voulez-vous exporter ${contactCount} contacts au format ${format.toUpperCase()} ?`,
      {
        confirmButtonText: 'Exporter',
        cancelButtonText: 'Annuler',
        icon: 'question'
      }
    );
  },

  // Confirmation de sauvegarde des paramètres
  saveSettings: async () => {
    return await alertService.confirmSave(
      'Sauvegarder les paramètres',
      'Voulez-vous sauvegarder les modifications apportées aux paramètres ?',
      {
        confirmButtonText: 'Sauvegarder',
        cancelButtonText: 'Annuler',
        icon: 'question'
      }
    );
  },

  // Confirmation de réinitialisation des paramètres
  resetSettings: async () => {
    return await alertService.confirmDelete(
      'Réinitialiser les paramètres',
      'Êtes-vous sûr de vouloir réinitialiser tous les paramètres aux valeurs par défaut ? Cette action est irréversible.',
      {
        confirmButtonText: 'Réinitialiser',
        cancelButtonText: 'Annuler',
        icon: 'warning'
      }
    );
  },

  // Confirmation de suppression multiple
  deleteMultiple: async (itemType, count) => {
    return await alertService.confirmDelete(
      `Supprimer ${count} ${itemType}`,
      `Êtes-vous sûr de vouloir supprimer ${count} ${itemType} sélectionnés ? Cette action est irréversible.`,
      {
        confirmButtonText: `Supprimer ${count} ${itemType}`,
        cancelButtonText: 'Annuler',
        icon: 'warning'
      }
    );
  },

  // Confirmation de déplacement de contacts
  moveContacts: async (contactCount, fromGroup, toGroup) => {
    return await alertService.confirm(
      'Déplacer les contacts',
      `Voulez-vous déplacer ${contactCount} contacts du groupe "${fromGroup}" vers "${toGroup}" ?`,
      {
        confirmButtonText: 'Déplacer',
        cancelButtonText: 'Annuler',
        icon: 'question'
      }
    );
  },

  // Confirmation de duplication d'une campagne
  duplicateCampaign: async (campaignName) => {
    return await alertService.confirm(
      'Dupliquer la campagne',
      `Voulez-vous créer une copie de la campagne "${campaignName}" ? La nouvelle campagne sera en mode brouillon.`,
      {
        confirmButtonText: 'Dupliquer',
        cancelButtonText: 'Annuler',
        icon: 'question'
      }
    );
  },

  // Confirmation de test d'envoi
  testSend: async (phoneNumber) => {
    return await alertService.confirm(
      'Envoyer un SMS de test',
      `Voulez-vous envoyer un SMS de test au numéro ${phoneNumber} ?`,
      {
        confirmButtonText: 'Envoyer',
        cancelButtonText: 'Annuler',
        icon: 'question'
      }
    );
  }
};

export default confirmationModals;
